export function DividerLine({ className = '' }: { className?: string }) {
	return <div className={`h-[4px] w-full bg-[var(--brand-primary)] ${className}`} />
}
